package pl.finn.forms.ezw

import io.kvision.redux.RAction
import pl.finn.forms.Zalacznik

enum class FormularzWidok {
  PUSTY,
  NOWY,
  EDYCJA
}

data class Formularz(
  val widok: FormularzWidok,
  val form: EzwForm? = null,
  val token: String? = null,
  val bladZapisu: String? = null

)

sealed class FormularzAction : RAction {
  data class Nowy(val formData: EzwFormData) : FormularzAction()
  data class Edycja(val formData: EzwFormData) : FormularzAction()
  data class DodajZalacznik(val zalacznik: Zalacznik, val aktualnyForm: EzwForm) : FormularzAction()
  data class UsunZalacznik(val nazwa: String, val aktualnyForm: EzwForm) : FormularzAction()
  data class BladZapisu(val bladZapisu: String, val aktualnyForm: EzwForm) : FormularzAction()
}

fun formularzReducer(state: Formularz, action: FormularzAction): Formularz = when (action) {
  is FormularzAction.Nowy -> {
    Formularz(
      FormularzWidok.NOWY,
      action.formData.form,
      action.formData.token,
      bladZapisu = null
    )
  }
  is FormularzAction.Edycja -> {
    Formularz(
      FormularzWidok.EDYCJA,
      action.formData.form,
      action.formData.token,
      bladZapisu = null
    )
  }
  is FormularzAction.DodajZalacznik -> {
    action.aktualnyForm.blokL2.zalaczniki.add(action.zalacznik)
    state.copy(form = action.aktualnyForm)
  }
  is FormularzAction.UsunZalacznik -> {
    action.aktualnyForm.blokL2.zalaczniki.forEach {
      if (it.nazwa == action.nazwa) {
        action.aktualnyForm.blokL2.zalaczniki.remove(it)
      }
    }
    state.copy(form = action.aktualnyForm)
  }
  is FormularzAction.BladZapisu -> {
    state.copy(bladZapisu = action.bladZapisu, form = action.aktualnyForm)
  }
}
